export const apiConstants = {
  units: '/units',
};
